export default "__VITE_ASSET__Bi3vDLL$__"